import request from '@/utils/request'

// 查询物料变更报表列表
export function apiMaterialChangeList(params) {
  return request({
    url: '/mes/wipChangeItemRecord/list',
    method: 'get',
    params: params
  })
}

// 导出物料变更报表
export function apiMaterialChangeExport(data) {
  return request({
    url: '/mes/wipChangeItemRecord/export',
    method: 'post',
    data: data
  })
}
